import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-widerrufsbelehrung',
    standalone: true,
    imports: [CommonModule, MarkdownModule],
    templateUrl: './widerrufsbelehrung.component.html',
    styleUrls: ['./widerrufsbelehrung.component.css']
})
export class WiderrufsbelehrungComponent { }
